// Importar todas las imágenes desde el archivo centralizado
import {
  Ambiodipina as ambiodipinaImg,
  Atorvastatin as atorvastatin,
  BiodipinaLP as biodipinaImg,
  Bionapril as bionapril,
  Bioprolol,
  Biotelmic,
  Carbiolol,
  Glimebio,
  Hidrobiozida,
  Olmebloc,
  Metforbio,
  CiclesonaT as Ciclesona,
  VentiduoPlus as Ventiduo,
  Chamber,
  DeslonilMt10mg as DeslonilMt,
  Biofixima400mg as Biofixima,
  Bioproxina500mg as Bioproxina,
  Cebiodroxilo500mg as Cebiodroxilo,
  Zitrobio,
  Biotahistin,
  Bioez,
  Bioflazacort,
  Biogavalina,
  Biosulfil,
  Biotamsul,
  Flubionazol,
  Fludisina,
  Pantobio,
  Quetiapine,
} from './productImages';

const tabs = [
  {
    id: 'cardiometabolicos',
    title: 'Cardiometabólica',
    bgColor: '#EE5BA0',
    textColor: '#FFFFFF',
    image: biodipinaImg,
    medicamentos: [
      {
        product: 'Ambiodipina',
        slug: `Control que se mantiene.`,
        desarr:
          'Reducción eficaz del LDL y prevención cardiovascular primaria y secundaria.',
        imagen: ambiodipinaImg,
      },
      {
        product: 'Atorvastatin',
        slug: `Tu colesterol bajo control. `,
        desarr:
          'Reducción eficaz del LDL y prevención cardiovascular primaria y secundaria.',
        imagen: atorvastatin,
      },
      {
        product: 'Biodipina LP',
        slug: `La presión no espera Biodipina LP actúa.`,
        desarr:
          'Tu aliado para el tratamiento de la hipertensión y la angina de pecho crónica estable. ',
        imagen: biodipinaImg,
      },
      {
        product: 'Bionapril',
        slug: `Doble protección en una toma.`,
        desarr:
          'Primera opción en el control de la hipertensión y protección renal.',
        imagen: bionapril,
      },
      {
        product: 'Bioprolol',
        slug: `Control con precisión, bienestar con confianza.`,
        desarr:
          'Eficacia cardiovascular con selectividad y tolerancia superior.',
        imagen: Bioprolol,
      },
      {
        product: 'Biotelmic',
        slug: `Control total cardiometabólico.`,
        desarr:
          'ARA  II con efecto metabólico. Cardioprotección perfil hepático favorable.',
        imagen: Biotelmic,
      },
      {
        product: 'Carbiolol',
        slug: `Ritmo estable, presión controlada.`,
        desarr:
          'Betabloqueante de referencia para hipertensión e insuficiencia cardíaca.',
        imagen: Carbiolol,
      },
      {
        product: 'Glimebio',
        slug: `Control sostenido. Confianza diaria.`,
        desarr:
          'Sulfonilurea de nueva generación, eficaz y segura como monoterapia o combinada',
        imagen: Glimebio,
      },
      {
        product: 'Hidrobiozida',
        slug: `El equilibrio que tu salud necesita.`,
        desarr: 'Eficacia diurética para una presión estable.',
        imagen: Hidrobiozida,
      },
      {
        product: 'Metforbio',
        slug: `Estabilidad glucémica con respaldo.`,
        desarr:
          'Primera elección en diabetes tipo 2, con bajo riesgo de hipoglucemia y efecto metabólico.',
        imagen: Metforbio,
      },
      {
        product: 'Olmebloc',
        slug: `Precisión que protege.`,
        desarr: 'Potencia antihipertensiva con seguridad renal.',
        imagen: Olmebloc,
      },
    ],
  },
  {
    id: 'respiratoria',
    title: 'Respiratoria',
    bgColor: '#E299BB',
    textColor: '#FFFFFF',
    image: biodipinaImg,
    medicamentos: [
      {
        product: 'Ciclesona-T',
        slug: `Innovación que cuentas`,
        desarr: 'Controla cada dosis, respira sin preocupaciones',
        imagen: Ciclesona,
      },
      {
        product: 'Ventiduo-Plus',
        slug: `Fórmula dual Control total.`,
        desarr: 'Doble acción: mayor eficacia para una mejor respiración.',
        imagen: Ventiduo,
      },
      {
        product: 'Chamber',
        slug: `Tranquilidad que apoya cada respiro.`,
        desarr: 'Cuando cuesta inhalar, Chamber lo hace facil.',
        imagen: Chamber,
      },
      {
        product: 'DeslonilMt 5mg',
        slug: `Respira sin interrupciones.`,
        desarr: 'Alivio sintomático sin causar somnolencia.',
        imagen: DeslonilMt,
      },
    ],
  },
  {
    id: 'antibiotica',
    title: 'Antibióticos',
    bgColor: '#FFE8F3',
    textColor: '#353535',
    image: biodipinaImg,
    medicamentos: [
      {
        product: 'Biofixima',
        slug: `Avanza con eficacia`,
        desarr:
          'Cefalosporina oral de 3ra generación: con cobertura extendida.',
        imagen: Biofixima,
      },
      {
        product: 'Bioproxina',
        slug: `Confianza terapéutica en cada tratamiento.`,
        desarr:
          'Alta penetración tisular y eficacia probada frente a patógenos claves',
        imagen: Bioproxina,
      },
      {
        product: 'Cebiodroxilo',
        slug: `Eficacia y seguridad`,
        desarr: 'Confianza y primera línea, en infecciones de tejido blando.',
        imagen: Cebiodroxilo,
      },
      {
        product: 'Zitrobio',
        slug: `Eficacia comprobada.`,
        desarr: 'Macrólido moderno de amplio espectro.',
        imagen: Zitrobio,
      },
    ],
  },
  {
    id: 'otros',
    title: 'Otros',
    bgColor: '#A9A9A9',
    textColor: '#FFFFFF',
    image: Zitrobio,
    medicamentos: [
      {
        product: 'Betahistina',
        slug: `Más estabilidad, Menos vértigo.`,
        desarr:
          'Control del vértigo en síndrome de Méniere con acción central e inmediata.',
        imagen: Biotahistin,
      },
      {
        product: 'Bioez',
        slug: `Cada dosis con el efecto que esperas.`,
        desarr:
          'Control sostenido del ácido gástrico. Ideal para ERGE, úlceras y terapias combinadas',
        imagen: Bioez,
      },
      {
        product: 'Bioflazacort',
        slug: `Efecto corticoide, cuidado total.`,
        desarr: 'Terapia prolongada, riesgo controlado.',
        imagen: Bioflazacort,
      },
      {
        product: 'Biogavalina',
        slug: `Equilibra tu sistema, mejora tu bienestar.`,
        desarr:
          'Alivio eficaz del dolor neuropático, con excelente tolerancia.',
        imagen: Biogavalina,
      },
      {
        product: 'Biosulfil (crema)',
        slug: `Cuidado dermatológico especializado.`,
        desarr:
          'Tratamiento tópico efectivo con acción antimicrobiana y antiinflamatoria.',
        imagen: Biosulfil,
      },
      {
        product: 'Biotamsul',
        slug: `Alivio que fluye.`,
        desarr:
          'Tratamiento para HBP, con selectividad alfa-1a y mínimo impacto sistémico.',
        imagen: Biotamsul,
      },
      {
        product: 'Flubionazol',
        slug: `Potencia y seguridad.`,
        desarr:
          'Antifúngico de amplio espectro, con excelente biodisponibilidad oral.',
        imagen: Flubionazol,
      },
      {
        product: 'Flunarazina',
        slug: `Tu aliado contra las migrañas.`,
        desarr:
          'Prevención efectiva de migrañas con efecto vasodilatador cerebral.',
        imagen: Fludisina,
      },
      {
        product: 'Pantobio Plus',
        slug: `Alivio más allá de la acidez.`,
        desarr:
          'Inhibidor confiable para el tratamiento integral de enfermedades ácido-dependientes.',
        imagen: Pantobio,
      },
      {
        product: 'Quetiapina',
        slug: `Equilibrio mental, bienestar integral.`,
        desarr:
          'Estabilidad y mente en calma. Manejo confiable de trastornos psiquiátricos.',
        imagen: Quetiapine,
      },
    ],
  },
];

export default tabs;
